/**
 * Walk Puck page JSON (and related meta) to find Studio file URLs still referenced.
 */
export function collectStudioAssetUrlsInUse(roots: unknown[]): Set<string> {
  const found = new Set<string>();

  function walk(value: unknown): void {
    if (typeof value === "string") {
      if (value.startsWith("/api/studio/files/")) {
        found.add(value);
      }
      return;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        walk(item);
      }
      return;
    }

    if (value && typeof value === "object") {
      for (const entry of Object.values(value)) {
        walk(entry);
      }
    }
  }

  for (const root of roots) {
    walk(root);
  }

  return found;
}

export function countStudioAssetUrlReferences(
  url: string,
  roots: unknown[],
): number {
  let count = 0;

  function walk(value: unknown): void {
    if (typeof value === "string") {
      if (value === url) {
        count += 1;
      }
      return;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        walk(item);
      }
      return;
    }

    if (value && typeof value === "object") {
      for (const entry of Object.values(value)) {
        walk(entry);
      }
    }
  }

  for (const root of roots) {
    walk(root);
  }

  return count;
}

export function isStudioAssetUrlInUse(
  url: string,
  urlsInUse: ReadonlySet<string>,
): boolean {
  return urlsInUse.has(url);
}
